module.exports = __webpack_public_path__ + "img/ic_water.30ff30fd.png";